import { Node, Parent } from 'unist'
import { visit } from 'unist-util-visit'

export function autoTelLink() {
  return transformer
}

function transformer(tree: Node) {
  visit(tree, 'text', visitor)
}

function visitor(
  node: Node & { value?: string },
  index: number | null,
  parent: Parent | undefined
) {
  const { value } = node
  if (typeof value !== 'string') {
    return
  }

  const match = /tel:(\(?0\d{1,3}\)?[-(]?\d{1,4}[-)]?\d{3,4})/.exec(value)

  if (!match) {
    return
  }
  const tel = match[1]
  const url = `tel:${tel}`
  const beforeLength = value.indexOf(url)
  const before = value.substring(0, beforeLength)
  const after = value.substring(beforeLength + url.length)

  const newChildren = []
  if (before) {
    newChildren.push({ type: 'text', value: before, children: [] })
  }
  newChildren.push({
    type: 'link',
    url,
    children: [{ type: 'text', value: tel, children: [] }],
  })
  if (after) {
    newChildren.push({ type: 'text', value: after, children: [] })
  }
  if (index === null || parent === undefined) {
    return
  }
  parent.children.splice(index, 1, ...newChildren)
}
